export default __webpack_public_path__ + "static/media/dbsHeader.ec23e5ba.png";